import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { currentUser } from '@/lib/api'
import { useIdleLogout } from '@/hooks/useIdleLogout'

export function RequireAuth() {
  const location = useLocation()
  useIdleLogout()

  if (!currentUser.get()) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  const user = currentUser.get()
  if (user?.must_change_password && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />
  }

  return <Outlet />
}
